var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export function loadImage(imageSrc) {
    return new Promise(function (resolve, reject) {
        var image = new Image();
        image.crossOrigin = 'Anonymous';
        image.onload = function () {
            resolve(image);
        };
        image.onerror = function () {
            reject(new Error("Image load error, image: " + imageSrc));
        };
        image.src = imageSrc;
    });
}
export function loadImages(imageSrcs) {
    return new Promise(function (resolve, reject) {
        var e_1, _a;
        var imageObjects = [];
        var total = imageSrcs.length;
        var finishLoadCount = 0;
        var _loop_1 = function (imageSrc) {
            var image = new Image();
            var imageData = { image: image };
            imageObjects.push(imageData);
            image.crossOrigin = 'Anonymous';
            image.onload = function () {
                finishLoadCount += 1;
                if (finishLoadCount === total) {
                    resolve(imageObjects);
                }
            };
            image.onerror = function (event, source, lineno, colno, error) {
                imageData.error = error;
                finishLoadCount += 1;
                if (finishLoadCount === total) {
                    resolve(imageObjects);
                }
            };
            image.src = imageSrc;
        };
        try {
            for (var imageSrcs_1 = __values(imageSrcs), imageSrcs_1_1 = imageSrcs_1.next(); !imageSrcs_1_1.done; imageSrcs_1_1 = imageSrcs_1.next()) {
                var imageSrc = imageSrcs_1_1.value;
                _loop_1(imageSrc);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (imageSrcs_1_1 && !imageSrcs_1_1.done && (_a = imageSrcs_1.return)) _a.call(imageSrcs_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    });
}
//# sourceMappingURL=loadImage.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/utils/loadImage.js
// module id = 499
// module chunks = 0